// extracted by mini-css-extract-plugin
module.exports = {"chip":"nav_document_analyzer_text-module__chip--3FyDg"};